<template>
	<div class="imageContainer" @click="goToActivityPage">
		<img :src="ImgServerUrl + '/act/p01/USDTChannel.webp'" alt="USDT" />
	</div>
</template>

<script>
import { SysKey } from "../../util/sysconfig";
export default {
	name: "crypto",
	data() {
		return {
			ImgServerUrl: SysKey("ImgServerUrl").SysValue,
		};
	},

	methods: {
		goToActivityPage() {
			const activityId = 20;
			this.$router.push("/preMain?ids=" + activityId);
		},
	},
};
</script>

<style lang="scss" scoped>
img {
	width: 100%;
	max-width: 100%;
}
.imageContainer {
	margin-top: 35px;
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/common/imageUSDT.vue